import { styled } from '@horizontal-org/shira-ui'

export const SceneWithFooter = styled.div`  
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
` 